import React, { useState, useRef, useEffect } from 'react';
import './LeftSidebar.css';
import SidebarMenuDropdown from '../leftSidebar/dropdowns/SidebarMenuDropdown';
import contalearn from '../../../header/images/logo.png';
import clasamenticon from '../images/clasamenticon.png';
import profileicon from '../images/profileicon.png';
import userManIcon from '../images/user_man.png';
import userWomanIcon from '../images/user_woman.png';
import userNeutralIcon from '../images/user_neutral.png';
import medaliiicon from '../images/medaliiicon.png';
import certificates from '../images/certificates.png';   
import misiune from '../images/misiune.png';
import moreicon from '../images/moreicon.png';
import homeicon from '../images/homeicon.png';
import smallLogo from '../images/logoconta.png';

const apiUrl = process.env.REACT_APP_API_URL;


const LeftSidebar = ({ onMenuSelect, selectedMenu }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownTimeout = useRef();
  const [gender, setGender] = useState(null);

  useEffect(() => {
    const fetchUserGender = async () => {
      try {
        const response = await fetch(`${apiUrl}/user`, { credentials: 'include' });
        if (!response.ok) return;

        const user = await response.json();
        setGender(user.gender || null);
      } catch (error) {
        setGender(null);
      }
    };

    fetchUserGender();
  }, []);

  const profileAvatar = gender === 'male'
    ? userManIcon
    : gender === 'female'
      ? userWomanIcon
      : gender === 'neutral'
        ? userNeutralIcon
        : profileicon;

  const handleMoreEnter = () => {
    if (dropdownTimeout.current) {
      clearTimeout(dropdownTimeout.current);
      dropdownTimeout.current = null;
    }
    setDropdownVisible(true);
  };
  const handleMoreLeave = () => {
    if (dropdownTimeout.current) clearTimeout(dropdownTimeout.current);
    dropdownTimeout.current = setTimeout(() => {
      setDropdownVisible(false);
      dropdownTimeout.current = null;
    }, 1000);
  };

  const handleDropdownEnter = () => {
    if (dropdownTimeout.current) {
      clearTimeout(dropdownTimeout.current);
      dropdownTimeout.current = null;
    }
    setDropdownVisible(true);
  };
  const handleDropdownLeave = () => {
    if (dropdownTimeout.current) clearTimeout(dropdownTimeout.current);
    dropdownTimeout.current = setTimeout(() => {
      setDropdownVisible(false);
      dropdownTimeout.current = null;
    }, 1000);
  };

    return (
      <>
        {/* Sidebar version (desktop) */}
        <div className="sidebar-menu-principal sidebar-menu-desktop">
          <div className="sidebar-logo">
            <img
              src={contalearn}
              className="logo-functional-page logo-large"
              alt="logo"
            />
            <img
              src={smallLogo}
              className="logo-functional-page logo-small"
              alt="logo"
            />
          </div>
          <ul className="sidebar-list">
            <li className={`sidebar-item${selectedMenu === 'Invata' ? ' active' : ''}`} onClick={() => onMenuSelect('Invata')}>
              <span className="sidebar-icon" role="img" aria-label="Journey"><img src={homeicon} className='icon-functional-page'/></span>
              <span className="sidebar-label">Invata</span>
            </li>
            <li className={`sidebar-item${selectedMenu === 'Misiuni' ? ' active' : ''}`} onClick={() => onMenuSelect('Misiuni')}>
              <span className="sidebar-icon" role="img" aria-label="Goals"><img src={misiune} className='icon-functional-page'/></span>
              <span className="sidebar-label">Misiuni</span>
            </li>
            <li className={`sidebar-item${selectedMenu === 'Clasament' ? ' active' : ''}`} onClick={() => onMenuSelect('Clasament')}>
              <span className="sidebar-icon" role="img" aria-label="Leaderboard"><img src={clasamenticon} className='icon-functional-page'/></span>
              <span className="sidebar-label">Clasament</span>
            </li>
          
            <li className={`sidebar-item${selectedMenu === 'Certificate' ? ' active' : ''}`} onClick={() => onMenuSelect('Certificate')}>
              <span className="sidebar-icon" role="img" aria-label="Store"><img src={certificates} className='icon-functional-page'/></span>
              <span className="sidebar-label">Certificate</span>
            </li>
            <li className={`sidebar-item${selectedMenu === 'Profil' ? ' active' : ''}`} onClick={() => onMenuSelect('Profil')}>
              <span className="sidebar-icon" role="img" aria-label="Profile"><img src={profileAvatar} className='icon-functional-page' alt="Profile" /></span>
              <span className="sidebar-label">Profil</span>
            </li>
            <li
              className="sidebar-item"
              onMouseEnter={handleMoreEnter}
              onMouseLeave={handleMoreLeave}
              style={{ position: 'relative' }}
            >
              <span className="sidebar-icon" role="img" aria-label="More"><img src={moreicon} className='icon-functional-page'/></span>
              <span className="sidebar-label">Mai multe</span>
              {/* <span className="sidebar-label">Mai multe</span> */}
              {/* Dropdown menu, positioned absolutely */}
              <div
                onMouseEnter={handleDropdownEnter}
                onMouseLeave={handleDropdownLeave}
                style={{ position: 'absolute', top: 0, left: '100%', zIndex: 99995 }}
              >
                <SidebarMenuDropdown visible={dropdownVisible} onMenuSelect={onMenuSelect} />
              </div>
            </li>
          </ul>
        </div>

        {/* Bottom nav version (mobile/tablet) */}
        <nav className="sidebar-menu-bottom">
          <ul className="sidebar-bottom-list">
            <li className={`sidebar-bottom-item${selectedMenu === 'Invata' ? ' active' : ''}`} onClick={() => onMenuSelect('Invata')}>
              <span className="sidebar-icon" role="img" aria-label="Journey"><img src={homeicon} className='icon-functional-page'/></span>
            </li>
            <li className={`sidebar-bottom-item${selectedMenu === 'Misiuni' ? ' active' : ''}`} onClick={() => onMenuSelect('Misiuni')}>
              <span className="sidebar-icon" role="img" aria-label="Goals"><img src={misiune} className='icon-functional-page'/></span>
            </li>
            <li className={`sidebar-bottom-item${selectedMenu === 'Clasament' ? ' active' : ''}`} onClick={() => onMenuSelect('Clasament')}>
              <span className="sidebar-icon" role="img" aria-label="Leaderboard"><img src={clasamenticon} className='icon-functional-page'/></span>
            </li>
            <li className={`sidebar-bottom-item${selectedMenu === 'Certificate' ? ' active' : ''}`} onClick={() => onMenuSelect('Certificate')}>
              <span className="sidebar-icon" role="img" aria-label="Store"><img src={certificates} className='icon-functional-page'/></span>
            </li>
           
            <li className={`sidebar-bottom-item${selectedMenu === 'Profil' ? ' active' : ''}`} onClick={() => onMenuSelect('Profil')}>
              <span className="sidebar-icon" role="img" aria-label="Profile"><img src={profileAvatar} className='icon-functional-page' alt="Profile" /></span>
            </li>
            <li className="sidebar-item-mai-multe">
              <span className="sidebar-icon" role="img" aria-label="More"><img src={moreicon} className='icon-functional-page'/></span>
            </li>
          </ul>
        </nav>
      </>
    );
};

export default LeftSidebar;
